
export const TiempoDelProveedor = (porcentaje: number): string => {
    if (porcentaje <= 33) return "bg-green-500";
    if (porcentaje <= 66) return "bg-yellow-300";
    return "bg-red-500";
}